import { orderXClient } from '@/service/client'
import {
  DataPayload,
  EconomicCalendarEventList,
  EconomicCalendarHistoryRequest,
} from '@/types/generated/public_api'
import type { ErrorResponse } from '@/types/service'

export async function fetchEconomicCalendarHistory(payload: EconomicCalendarHistoryRequest) {
  try {
    const { data } = await orderXClient.post<DataPayload>(
      '/api',
      { economicCalendarHistory: payload },
      { headers: { 'X-Decode-Key': 'datapayload' } }
    )
    const eventList = data.economicCalendarEventList
    if (!eventList) {
      return Promise.reject({
        status: 400,
        message: 'Failed to fetch economic calendar history',
      })
    }
    return eventList as EconomicCalendarEventList
  } catch (e) {
    const error = e as ErrorResponse
    return Promise.reject(error)
  }
}
